import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { bindActionCreators } from 'redux'
import { push } from 'connected-react-router'
import queryString from 'query-string'

import * as OrgActions from 'modules/org/actions'
import * as RoutingSelectors from 'modules/routing/selectors'

import LoadingPage from 'layouts/LoadingPage'

const mapStateToProps = state => ({
  search: RoutingSelectors.getSearch(state),
  pathname: RoutingSelectors.getPathname(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
    exchangeGoogleCodeForDriftCode: OrgActions.exchangeGoogleCodeForDriftCode,
    exchangeMicrosoftCodeForDriftCode: OrgActions.exchangeMicrosoftCodeForDriftCode
  }, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onProcessingExternalGoogleCode: props => event => {
      event && props.actions.exchangeGoogleCodeForDriftCode({ code: event, pathname: props.pathname })
    },
    onProcessingMicrosoftCode: props => event => {
      event && props.actions.exchangeMicrosoftCodeForDriftCode({ code: event, pathname: props.pathname })
    },
  }),
  lifecycle({
    componentDidMount() {
      const { search, pathname } = this.props

      if (search && pathname.includes("google")) {
        const token = queryString.parse(search).code
        this.props.onProcessingExternalGoogleCode(token)
      }
      if (search && pathname.includes("microsoft")) {
        const token = queryString.parse(search).code
        this.props.onProcessingMicrosoftCode(token)
      }
    }
  }),
)(LoadingPage)
